<form [formGroup]="form" (ngSubmit)="confirmar()" class="grid grid-cols-3 gap-x-8 gap-y-4">
    <div class="flex flex-col">
        <label for="poliza">Número de Póliza</label>
        <input pInputText type="number" id="poliza" formControlName="poliza" placeholder="Ingrese el número de póliza"
            class="w-full" />
        <app-input-error [control]="form.get('poliza')"></app-input-error>
    </div>

    <div class="flex flex-col">
        <label for="vencimiento">Fecha de Vencimiento</label>
        <p-datepicker [showIcon]="true" [iconDisplay]="'input'" id="vencimiento" formControlName="fecha_vencimiento"
            dateFormat="dd/mm/yy" placeholder="dd/mm/aaaa" class="w-full" appendTo="body" [style]="{width: '100%'}"
            [inputStyle]="{width: '100%'}" />
    </div>

    <div class="flex flex-col gap-1">
        <label htmlFor="adjunto" class="text-sm font-medium">Adjunto</label>
        <div class="w-full flex" style="align-items: flex-start;">
            <p-fileUpload
                mode="basic"
                name="adjunto"
                chooseLabel="Adjuntar archivo"
                chooseIcon="pi pi-upload"
                [auto]="false"
                [customUpload]="true"
                (onSelect)="onAdjuntoSelect($event)"
                (onClear)="onAdjuntoClear()"
                (onRemove)="onAdjuntoClear()"
                class="flex-shrink-0"
            />
        </div>
    </div>

    <div class="flex flex-col">
        <label for="vehiculos" class="mb-2">Vehículos Asociados a la Póliza</label>
        <p-listbox [options]="vehiculos" [multiple]="true" formControlName="vehiculos"
            placeholder="Seleccionar vehículos" [style]="{width: '500px'}" />
    </div>

    <div class="flex justify-end gap-3 col-span-1 md:col-span-2 lg:col-span-3 w-full">
        <button pButton type="button" label="Cancelar" class="p-button-secondary" (click)="cancelar()"></button>
        <button pButton type="submit" label="Confirmar" [disabled]="form.invalid"></button>
    </div>
</form>